import { JoinField, RelationshipField } from 'payload'
import { FieldDefault, FieldWithouType } from '@utils/fields'
import { mergeObjects } from '@utils/objects';

/**
 * Creates a Relationship Field for Payload
 * Will allow set it only in creation
 *
 * @param config
 * @returns
 */
export function createOnlyField(config: WithOneRequired<FieldWithouType<CustomPayloadField<RelationshipField>>, 'relationTo'>): CustomPayloadField<RelationshipField>[] {
  const field: Omit<FieldDefault<RelationshipField>, 'relationTo'> = {
    type: 'relationship',
    maxDepth: 2,
    required: true,
    admin: {
      allowCreate: false,
      allowEdit: false,
      components: {
        Field: '@components/(payload)/fields/relationship/create-only',
      }
    },
  };

  return [ mergeObjects(field, config) ];
}

/**
 * Creates a Join Field for Payload
 *
 * @param config
 * @returns
 */
export function joinRelationshipField(config: WithOneRequired<FieldWithouType<CustomPayloadField<JoinField>>, 'collection' | 'on'>): CustomPayloadField<RelationshipField>[] {
  const defaultSort = config?.defaultSort || ['title'];
  const defaultColumns = config?.admin?.defaultColumns || ['title'];

  const field: Omit<FieldDefault<JoinField>, 'collection' | 'on'> = {
    type: 'join',
    defaultLimit: 0,
    defaultSort,
    maxDepth: 2,
    admin: {
      defaultColumns,
      components: {
        Label: '@components/(payload)/fields/empty',
      }
    },
  };

  return [ mergeObjects(field,config) ];
}
